import { CanDeactivate } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import Swal from "sweetalert2";

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable()
export class PendingChangesGuard
  implements CanDeactivate<ComponentCanDeactivate>
{

  constructor(private translate:TranslateService){

  }
  canDeactivate(
    component: ComponentCanDeactivate
  ): boolean | Observable<boolean> {
    // if there are no pending changes, just allow deactivation; else confirm first

    if (component.canDeactivate()) {
      return true;
    } else {
      return Observable.create((observer: any) => {
        Swal.fire({
          title: this.translate.instant("Unsaved Changes"),
          text: this.translate.instant("You have made changes to this entry without saving. If you wish to save them go back and press the 'Save Entry' button."),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "$primary",
          cancelButtonColor: "#d33",
          confirmButtonText: this.translate.instant("Go back and save the changes"),
          cancelButtonText: this.translate.instant("Exit without saving"),
        }).then((result) => {
          if (result.value == true) {
            observer.next(false);
          } else {
            observer.next(true);
          }
        });
      });
    }
  }
}
